export default {
  // current_activity_type shows you if you are currently viewing
  // ie. 'live-discussion' or 'online'
  // so that you know what to display if you navigate back from other tabs
  fullScreen: false,
  showSlidingRoundtableList: true,
  current_activity_type: null,
  loading: false,
  dashboard_role: null,
  courseList: [],
  instructor_courses: [],
  participant_courses: [],
  total_instructor_courses: 0,
  total_participant_courses: 0,
  courseDetail: {
    id: null,
    users: [],
    roundtables: [],
    points_settings: [],
    saved_live_feedback: [],
    saved_online_feedback: [],
    sections: [],
    title: 'Title',
    live_discussions: [],
    invites: [],
    chat_is_enabled: null,
    unread_messages: 0,
    google_classroom_course_id: null,
    google_classroom_course_name: null,
    edlink_course_id: null,
    edlink_course_name: null,
    edlink_integrations: {}
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/courses/state.js